import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';
import { useMemo } from 'react';

export default function SlotsGameContentGameDetailsSkeleton() {
  const Chips = useMemo(
    () =>
      Array.from({ length: 3 }).map((_, index) => (
        <div className={skeleton.chip} key={`skeleton-chip-${index}`} />
      )),
    [],
  );
  return (
    <div className={styles.card}>
      <div className={styles.card__column}>
        <div className={styles.card__column__title}>
          <div className={skeleton.title} />
        </div>
        <div className={styles.card__column__description}>
          <div className={skeleton.description} />
        </div>
      </div>
      <div className={styles.card__chips}>{Chips}</div>
    </div>
  );
}
